// Lib: https://tarekraafat.github.io/autoComplete.js/
// Ref: https://tarekraafat.github.io/autoComplete.js/#/playground
//
// Notes:
// replaces resources/assets/vue/components/common/global-search-bar.vue
// implementation as its gets flagged by google lighthouse for LCP

import AutoComplete from '@tarekraafat/autocomplete.js';
import EventBus from '@/event-bus';
import generateConfig from './autocomplete-config';

const $container = document.querySelector('#js-vanilla-search');
const inputSelector = '#js-mobile-search';

function blurSearchField() {
  document.querySelector(inputSelector).blur();
}

function clearSearchField() {
  document.querySelector(inputSelector).value = '';
}

function setupMobileAutocomplete() { //eslint-disable-line

  EventBus.$on('bus:search-mutations:clear', clearSearchField);

  const $loadingContainer = $container.querySelector('.LoadingScreen');

  const config = generateConfig({ inputSelector, $loadingContainer });

  const autoCompleteJS = new AutoComplete(config); //eslint-disable-line

  autoCompleteJS.input.addEventListener('init', (event) => {
    console.log('mobile-search:init', event);
  });

  autoCompleteJS.input.addEventListener('selection', (event) => {
    console.log('mobile-search:selected', event.detail);

    const newValue = event.detail.selection.value.name;

    autoCompleteJS.input.value = newValue;
    blurSearchField();
    EventBus.$emit('bus:mobile-header:search', newValue);
  });

  $container.querySelector('#js-mobile-search-button').addEventListener('click', (event) => {
    event.preventDefault();
    blurSearchField();
    EventBus.$emit('bus:mobile-header:search', autoCompleteJS.input.value);
  });

  $container.querySelector('#js-mobile-search').addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      blurSearchField();
      EventBus.$emit('bus:mobile-header:search', autoCompleteJS.input.value);
    }
  });
}

function toggleMobileTabsActiveClass($currentTab) {
  const $tabs = $container.querySelectorAll('.VanillaSearch-link');

  $tabs.forEach(($tab) => {
    $tab.classList.remove('is-active');
  });

  $currentTab.classList.add('is-active');
}

function setupMobileTabs() {
  const $tabs = $container.querySelectorAll('.VanillaSearch-link');

  $tabs.forEach(($tab) => {
    $tab.addEventListener('click', (event) => {
      event.preventDefault();
      const searchType = event.target.href.split('show=')[1];

      toggleMobileTabsActiveClass($tab);

      EventBus.$emit('bus:mobile-header:navigation', searchType);
    });
  });
}

if ($container !== null) {
  setupMobileAutocomplete();
  setupMobileTabs();
}
